export default __webpack_public_path__ + "static/media/LAS0160.34I-30557_-17575_0.47fbae84.jpg";